import { Col, Container, Image, Row } from 'react-bootstrap';
import Buttons from '../../../Litho/Components/Button/Buttons';
import colors from '../../../constants/colors';
import useResponsiveScreen from '../../../hooks/useResponsiveScreen';
import { useNavigate } from 'react-router-dom';

const LandingSection = () => {
	const { isMobile } = useResponsiveScreen();
	const navigate = useNavigate();

	const handleRedirect = () => {
		navigate('/track-shipment');
	};

	return (
		<div className='container flex flex-col items-center'>
			<Container>
				<Row className='items-center justify-between pt-20 sm:!pt-5'>
					<Col lg={12} md={12} sm={12}>
						<h2 className='font-calistoga text-ttertiary font-semibold text-center sm:!text-[28px] !text-3xl mb-[2.5rem] sm:mb-[20px] xs:mb-[15px] tracking-wider'>
							Grow your business.{' '}
							<span className='text-tprimary'>
								We will
								<br className='sm:hidden inline' /> take care
							</span>{' '}
							all your logistic
						</h2>
						<p className='text-tgray text-center notMobile:w-[70%] mx-auto'>
							It's time to adapt your business to keep up with how the world of
							commerce is evolving. Onlineize your offline logistics service.
							Booking, controlling, and monitoring your shipments are all
							simple with Interlink Oceana.
						</p>
						<div className='flex gap-16 items-center justify-center pt-8'>
							<Buttons
								ariaLabel='tab button'
								className='rounded-full font-medium font-serif bg-tprimary hover:!bg-red-700 hover:shadow-xl text-white hover:text-ttertiary tracking-[1px] uppercase md:mb-[15px] xs:mb-0 xs:mt-[20px]'
								size={isMobile ? 'md' : 'lg'}
								themeColor={colors.tprimary}
								to='/contact'
								title='Contact Us'
							/>
							{/* text button */}
							<button
								className='text-tgray font-semibold font-serif bg-transparent tracking-[1px] md:mb-[15px] xs:mb-0 xs:mt-[20px]'
								onClick={handleRedirect}
							>
								Start Tracking
							</button>
						</div>
					</Col>
				</Row>
				<Image
					src='/assets/img/home-page/shipment-loading.jpg'
					className='mt-16 rounded-xl'
				/>
			</Container>
		</div>
	);
};

export default LandingSection;
